function view (path) {
  return () => import(/* webpackChunkName: 'rs-regional-v2' */ '@/views/rsm/' + path + '.vue').then(m => m.default || m) // eslint-disable-line prefer-template
}

const RRSManager = [
  {
    path: '/rsm/dashboard',
    component: view('dashboard/Base'),
    name: 'rsm.dashboard'
  },
  {
    path: '/rsm/customers',
    component: view('Customers'),
    name: 'rsm.customers',
    meta: {
      breadcrumb: [
        {
          text: 'RSM',
          to: {
            name: 'rsm.dashboard'
          }
        },
        {
          text: 'Customers',
          active: true
        }
      ]
    }
  },
  {
    path: '/rsm/customers/:customer?/managements',
    component: view('customer-management/Base'),
    name: 'rsm.customers.profile',
    meta: {
      breadcrumb: [
        {
          text: 'RSM',
          to: {
            name: 'rsm.dashboard'
          }
        },
        {
          text: 'Customers',
          to: {
            name: 'rsm.customers'
          }
        },
        {
          text: 'Customer Profile',
          active: true
        }
      ]
    }
  },
  {
    path: '/rsm/area-managers',
    component: view('AreaManagerUsers'),
    name: 'rsm.area-managers',
    meta: {
      breadcrumb: [
        {
          text: 'RSM',
          to: {
            name: 'rsm.dashboard'
          }
        },
        {
          text: 'Area Managers',
          active: true
        }
      ]
    }
  },
  {
    path: '/rsm',
    component: view('Memos'),
    children: [
      {
        path: 'memos',
        component: view('memos/Base'),
        name: 'rsm.memos',
        meta: {
          breadcrumb: [
            {
              text: 'RSM',
              to: {
                name: 'rsm.dashboard'
              }
            },
            {
              text: 'Memos',
              active: true
            }
          ]
        }
      },
      {
        path: 'signed-memos',
        component: view('memos/signed-memos/Base'),
        name: 'rsm.memos.signed-memos',
        meta: {
          breadcrumb: [
            {
              text: 'RSM',
              to: {
                name: 'rsm.dashboard'
              }
            },
            {
              text: 'Memos',
              active: true
            }
          ]
        }
      }
    ]
  }
]

const RRSManagerAreaManager = [
  {
    path: '/rsm/area-managers/tracking/other-activities',
    component: view('area-managers/OtherEvents'),
    children: [
      {
        path: 'activities',
        component: view('area-managers/other-events/Base'),
        name: 'rsm.area-managers.other-events',
        meta: {
          breadcrumb: [
            {
              text: 'RSM',
              to: {
                name: 'rsm.dashboard'
              }
            },
            {
              text: 'ASM Tracking'
            },
            {
              text: 'Other Activities',
              active: true
            }
          ]
        }
      },
      {
        path: 'reports',
        component: view('area-managers/reports/OtherEvents'),
        name: 'rsm.area-managers.other-events.reports',
        meta: {
          breadcrumb: [
            {
              text: 'RSM',
              to: {
                name: 'rsm.dashboard'
              }
            },
            {
              text: 'ASM Tracking'
            },
            {
              text: 'Other Activities',
              active: true
            }
          ]
        }
      }
    ]
  },
  {
    path: '/rsm/area-managers/tracking/monthly-plans',
    component: view('area-managers/monthly-plans/Base'),
    name: 'rsm.area-managers.monthly-plans',
    meta: {
      breadcrumb: [
        {
          text: 'RSM',
          to: {
            name: 'rsm.dashboard'
          }
        },
        {
          text: 'ASM Tracking'
        },
        {
          text: 'Monthly Plans',
          active: true
        }
      ]
    }
  }
]

const RRSManagerAreaManagerReports = [
  {
    path: '/rsm/area-managers/reports/monthly-plans',
    component: view('area-managers/reports/MonthlyPlans'),
    name: 'rsm.area-managers-reports.monthly-plans',
    meta: {
      breadcrumb: [
        {
          text: 'RSM',
          to: {
            name: 'rsm.dashboard'
          }
        },
        {
          text: 'ASM Reports'
        },
        {
          text: 'Monthly Plans',
          active: true
        }
      ]
    }
  }
]

const RRSManagerOfficer = [
  {
    path: '/rsm/officers/tracking/task-events',
    component: view('officers/events/Events'),
    name: 'rsm.officers.events',
    meta: {
      breadcrumb: [
        {
          text: 'RSM',
          to: {
            name: 'rsm.dashboard'
          }
        },
        {
          text: 'FSO Tracking'
        },
        {
          text: 'Task Events',
          active: true
        }
      ]
    }
  },
  {
    path: '/rsm/officers/tracking/other-activities',
    component: view('officers/OtherEvents'),
    children: [
      {
        path: 'activities',
        component: view('officers/other-events/Base'),
        name: 'rsm.officers.other-events',
        meta: {
          breadcrumb: [
            {
              text: 'RSM',
              to: {
                name: 'rsm.dashboard'
              }
            },
            {
              text: 'FSO Tracking'
            },
            {
              text: 'Other Activities',
              active: true
            }
          ]
        }
      },
      {
        path: 'reports',
        component: view('officers/reports/OtherEvents'),
        name: 'rsm.officers.other-events.reports',
        meta: {
          breadcrumb: [
            {
              text: 'RSM',
              to: {
                name: 'rsm.dashboard'
              }
            },
            {
              text: 'FSO Tracking'
            },
            {
              text: 'Other Activities',
              active: true
            }
          ]
        }
      }
    ]
  },
  {
    path: '/rsm/officers/tracking/monthly-plans',
    component: view('officers/monthly-plans/Base'),
    name: 'rsm.officers.monthly-plans',
    meta: {
      breadcrumb: [
        {
          text: 'RSM',
          to: {
            name: 'rsm.dashboard'
          }
        },
        {
          text: 'FSO Tracking'
        },
        {
          text: 'Monthly Plans',
          active: true
        }
      ]
    }
  }
]

const RRSManagerOfficerReports = [
  {
    path: '/rsm/officers/reports/tasks',
    component: view('officers/reports/Tasks'),
    name: 'rsm.officer-reports.tasks',
    meta: {
      breadcrumb: [
        {
          text: 'RSM',
          to: {
            name: 'rsm.dashboard'
          }
        },
        {
          text: 'FSO Reports'
        },
        {
          text: 'Tasks',
          active: true
        }
      ]
    }
  },
  {
    path: '/rsm/officers/reports/monthly-plans',
    component: view('officers/reports/MonthlyPlans'),
    name: 'rsm.officer-reports.monthly-plans',
    meta: {
      breadcrumb: [
        {
          text: 'RSM',
          to: {
            name: 'rsm.dashboard'
          }
        },
        {
          text: 'FSO Reports'
        },
        {
          text: 'Monthly Plans',
          active: true
        }
      ]
    }
  }
]

export default RRSManager.concat(
  RRSManagerAreaManager,
  RRSManagerOfficer,
  RRSManagerAreaManagerReports,
  RRSManagerOfficerReports
)
